import html2canvas from 'html2canvas';

type optionsType = {
    width: number;
    height: number;
    background: string;
    format: 'image/jpeg' | 'image/png';
    quality: number;
};

const defaultParams: optionsType = {
    height: 850,
    width: 860,
    background: '#FFF',
    format: 'image/jpeg',
    quality: 0.3,
};

/**
 *
 * @param element !IMPORTANT: element should be attached to window
 * @param options
 */
const takeScreenshot = (element: HTMLElement, options = defaultParams): Promise<string> | any => html2canvas(element, {
        height: options.height,
        width: options.width,
        windowHeight: options.height,
        windowWidth: options.width,
        imageTimeout: 0,
        scrollX: 0,
        scrollY: 0,
        removeContainer: true,
        useCORS: true,
    })
        .then((canvas) => canvas.toDataURL(options.format, options.quality))
        .catch((e) => {
            console.log(e);
        });

export { takeScreenshot };
export default takeScreenshot;
